// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2ekHV","col":"CardReaderDesc_col__31dFP","label":"CardReaderDesc_label__3Z3m1"};